/**
 * Returns height of visible in window part of element
 * https://stackoverflow.com/questions/24768795/get-the-visible-height-of-a-div-with-jquery
 * @param el - dom node
 */
export function viewportHeight(el: HTMLDivElement) {
  const elHeight = el.offsetHeight,
    winHeight = window.innerHeight,
    rect = el.getBoundingClientRect(),
    rectTop = rect.top,
    rectBot = rect.bottom;
  return Math.max(0, rectTop > 0 ? Math.min(elHeight, winHeight - rectTop) : Math.min(rectBot, winHeight));
}
